function n(n){return n instanceof Date&&!isNaN(+n)}export{n as isDate};
